// extracted by mini-css-extract-plugin
export var brand = "_8o-9";
export var compact = "_8o-6";
export var extraSmall = "_8o-7";
export var icon = "_8o-0";
export var large = "_8o-4";
export var light = "_8o-1";
export var medium = "_8o-5";
export var outline = "_8o-b";
export var primaryDark = "_8o-a";
export var primaryLight = "_8o-8";
export var primaryModern = "_8o-c";
export var success = "_8o-2";
export var successSolid = "_8o-3";